"use strict";

import { isInViewport } from "./helpers";

export function initInteractiveProductShowcase() {
    $('.interactive-product-showcase__video')
        .on('pause', function(){
            $(this).addClass('interactive-product-showcase__video--not-playing');
            console.log('video paused', this, this.classList);
        })
        .on('play', function(){
            $(this)
                .removeAttr('autoplay-video-in-viewport')
                .removeClass('interactive-product-showcase__video--not-playing');
            console.log('video play', this, this.classList);
        })
        .on('canplaythrough', function(){
            console.log('video canplaythrough', this, this.classList);
            if (isInViewport(this) && this.hasAttribute('autoplay-video-in-viewport')) {
                this.play()
                    .then(() => {
                        $(this)
                            .removeClass('interactive-product-showcase__video--not-playing')
                            .addClass('interactive-product-showcase__video--loaded');
                        console.log('video canplaythrough - autoplay when in viewport', this, this.classList);
                    })
                    .catch((error) => {
                        $(this)
                            .addClass('interactive-product-showcase__video--not-playing')
                            .addClass('interactive-product-showcase__video--error');
                        console.log('video canplaythrough - play unsuccessful', error);
                    });
            }
        });

    $('.interactive-product-showcase__restart-video').on('click', function(){
        const video = $(this).closest('.interactive-product-showcase').find('.interactive-product-showcase__video').get(0);
        video.classList.remove('interactive-product-showcase__video--not-playing');
        // Wait while buttons transition become hidden
        setTimeout(() => {
            video.play();
        }, 500);
    });
}

export default function init(){
    initInteractiveProductShowcase();
}